goog.provide('el8.apphome.scheduler.dialog.apptDetails');

goog.require('el8.data.apptStatuses');
goog.require('el8.data.practiceUsers');
goog.require('el8.template.apphome.scheduler.dialog');
goog.require('el8.template.appshared.location');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.FormDialog');
goog.require('el8.util.amplitude.schedulerHelpers');
goog.require('el8.util.consts');
goog.require('el8.util.datecompare');
goog.require('el8.util.string');


el8.apphome.scheduler.dialog.apptDetails = (function() {

    var that = {};

    that.show = function(spec) {
        spec = spec || {};

        if (spec.appt) {
            el8React.dispatch.openEditAppointmentDialog(spec.appt.getId());
        } else {
            var createOptions;
            if (spec.patientItem) {
                createOptions = {
                    patientId: spec.patientItem.id,
                    patientName: spec.patientItem.name,
                };
            }
            el8React.dispatch.openCreateAppointmentDialog(spec.physicianUserId, undefined, createOptions);
        }
    };

    return that;

})();
